// removed by extract-text-webpack-plugin
module.exports = {"InfoText":"_3XfS6ugZ2UCuHMQ9TPIkTb","border":"_3Gh0mKoVB8Qp5WSCxfTTfh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/InfoText.css
// module id = 276
// module chunks = 8